import React, { Component } from 'react';
import ProjectsLayout from '../../templates/project';
import RegisterEditForm from '../../elements/project/owner';
import Loading from "../../elements/loading";

class ProjectOwner extends Component {
	render (){
		let { project,modalities } = this.props;
		return (
			project.owner.isFetching || modalities.isFetching ?
				<Loading message="Cargando..."/>:<RegisterEditForm
													owner={project.owner}
													permissions={project.permissions}
													modalities={modalities}
													match={this.props.match}
													history={this.props.history}
													saveOwner={this.props.saveOwner}
													setSystemNotification={this.props.setSystemNotification}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.fetchModalities();
		this.props.fetchOwner(modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;
		if(this.props.location.pathname !== newprops.location.pathname) {
			this.props.fetchOwner(modality, state, municipality);
		}
	}
}

export default ProjectsLayout(ProjectOwner, {subnav: 1});



// WEBPACK FOOTER //
// ./src/layouts/project/owner.jsx